import React, { Component } from 'react';
import { safeParse } from '../utils';

class App extends Component {

  render() {
    const data = this.props?.data || {}
    const products = data?.podmena_products || []

    return (
      <div className='mt-[95px] xl:mt-[150px] leading-none'>
        <div className='container'>
          <h1 className='font-medium xl:mt-[40px] tracking-[-0.04em] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start'>
            {safeParse(data?.pagetitle)}
          </h1>
          {products.length > 0 && (
            <div className='grid grid-cols-2 xl:grid-cols-5 gap-[19px] mt-[30px] xl:mt-[40px]'>
              {products.map((elm, k) => (
                <a
                  href={elm?.url}
                  key={k}
                  className='group leading-none tracking-[-0.04em] no-underline'
                >
                  <div className='flex items-center justify-center overflow-hidden bg-[#F5F2F4] rounded-[15px] w-full h-[211px] xl:h-[271px] relative'>
                    <div className="absolute top-[15px] right-[15px] xl:top-[20px] xl:right-[20px] w-[30px] h-[30px] xl:w-[35px] xl:h-[35px] rounded-full bg-white flex items-center justify-center text-black text-[16px] xl:text-[18px] leading-none transition-all duration-300 cursor-pointer group-hover:bg-[#009EE3] group-hover:text-white">
                      <svg width="13" height="5" viewBox="0 0 13 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.25209 4.35598C9.40809 3.99598 9.57009 3.67798 9.73809 3.40198C9.90609 3.11398 10.0741 2.86798 10.2421 2.66398H9.39667e-05V1.69198H10.2421C10.0741 1.47598 9.90609 1.22998 9.73809 0.953984C9.57009 0.665984 9.40809 0.347984 9.25209 -1.61529e-05H10.0981C10.8541 0.875984 11.6521 1.52398 12.4921 1.94398V2.41198C11.6521 2.81998 10.8541 3.46798 10.0981 4.35598H9.25209Z" fill="currentColor"/>
                      </svg>
                    </div>
                    <img className='object-contain w-full h-full p-[15px]' src={elm?.image} alt={elm?.pagetitle} width={137} height={192} />
                  </div>
                  <div className='mt-[14px] text-[16px] xl:text-[18px] tracking-[-0.04em] text-[#032432] leading-none'>
                    {safeParse(elm?.longtitle)}
                  </div>
                </a>
              ))}
            </div>
          )}
          <div className='mt-[50px] text-black/60 text-[14px] xl:text-[16px] text-center xl:text-start page_content'>{safeParse(data?.content)}</div>
        </div>
      </div>
    );
  }
}

export default App;